import { Instance } from 'mobx-state-tree';
import { ProjectDeletedDtoModelBase } from './ProjectDeletedDtoModel.base';

/* The TypeScript type of an instance of ProjectDeletedDtoModel */
export interface ProjectDeletedDtoModelType extends Instance<typeof ProjectDeletedDtoModel.Type> {}

/* A graphql query fragment builders for ProjectDeletedDtoModel */
export { selectFromProjectDeletedDto, projectDeletedDtoModelPrimitives, ProjectDeletedDtoModelSelector } from './ProjectDeletedDtoModel.base';

/**
 * ProjectDeletedDtoModel
 */
export const ProjectDeletedDtoModel = ProjectDeletedDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
